import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom"; // CRA routing
import "../styles/index.css";
import videoFile from "../images/makers-web-lava.mp4";
import mhiImage from "../images/mhi_white.png";
import Header from "../components/Header";
import { ImageCarousel } from "../components/MainCarousel";
import Footer from "../components/Footer";
import BackgroundCarousel from "../components/BackgroundCarousel";

export const IndexPage = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 2.0;
    }
  }, []);

  return (
    <>
    {/* Header */}
    <Header />
    <main>
      {/* Landing Section */}
      <section className="video-section">
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          className="background-video"
          playsInline
        >
          <source src={videoFile} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="overlay">
          <h1>
            where engineering <br /> meets expression
          </h1>
          <p>
            A community of students bringing <br />
            their wildest ideas to life.
          </p>
          <img src={mhiImage} alt="USC Ming Hsieh Institute" />
        </div>
      </section>

      {/* Who We Are Section */}
      <section className="who-we-are-header">
        <h2>who we are</h2>
      </section>

      <section className="who-we-are-text">
        <div>
          <p>
            Makers is a community of USC students passionate about going beyond
            the textbook and turning our wildest ideas into real engineering
            projects.
          </p>
          <p>
            We work in teams of 5-7 to develop ~10 projects throughout the year.
            These projects are entirely student-led, from ideation to
            realization.
          </p>
          <p>
            We aim to facilitate exploration of topics within electrical,
            computer, and mechanical engineering, as well as computer science.
          </p>
          <p>
            Anyone with a passion for making is welcome to join our community!
          </p>
        </div>
        <div>
          <ImageCarousel />
        </div>
      </section>

      {/* Centered Button */}
      <div className="learn-more-button">
        <Link to="/about" className="learn-more-button-details">
          learn more!
        </Link>
      </div>

      <section className="join-section" style={{ paddingTop: "80px" }}>
        <BackgroundCarousel />
      </section>


    </main>
    {/* Footer */}
    <Footer />
    </>
  );
};

export default IndexPage;
